import { Component, Prop, h, Host } from '@stencil/core';
import { SignNowLogo } from '../shared/sn-logo';

const COMPONENT_NAME = 'sn-navbar-type-2';

/**
 * Minimal navbar with the SignNow logo left-aligned. Designed for landing pages and focused conversion flows.
 *
 * @product signnow
 * @version 2.0.0
 * @category SignNow
 * @source navbar
 * @example
 *   <sn-navbar-type-2></sn-navbar-type-2>
 */
@Component({
  tag: 'sn-navbar-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNNavbarType2 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';
  @Prop({ attribute: 'logo-href' }) logoHref: string = '/';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <header class={COMPONENT_NAME}>
          <nav class="sn-navbar-type-2__container" role="navigation" aria-label="Main navigation">
            <div class="sn-navbar-type-2__logo-column">
              <a href={this.logoHref} class="sn-navbar-type-2__logo-link" aria-label="SignNow - Go to homepage">
                <SignNowLogo />
              </a>
            </div>
          </nav>
        </header>
      </Host>
    );
  }
}
